import{useContext as r}from"react";import{DevCenterRouterContext as t}from"../DevCenterRouterContext.js";function e(){return r(t)}export{e as useDevCenterRouter};
